const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const initialState = { conversations: {} }

const favoriteMessagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_FAVORITE_MESSAGES_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'FAVORITE_MESSAGES_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_FAVORITE_MESSAGES':
      return {
        ...state,
        status: {
          get_favorite_messages: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_FAVORITE_MESSAGES':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.chatId]: [...action.payload.data],
        },
        status: {
          ...state.status,
          get_favorite_messages: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'UPDATE_FAVORITE_MESSAGES': {
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.chatId]: [...action.payload.data],
        },
        status: {
          ...state.status,
          update_favorite_messages: {
            ...initialStatus,
            success: true,
          },
        },
      }
    }

    default:
      return state
  }
}

export default favoriteMessagesReducer
